import { makeRequestGet, makeRequestGet2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getStatus() {
  return makeRequestGet(`status/`);
}
